// extracted by mini-css-extract-plugin
module.exports = {"icon":"Footer_icon__2fpab","container":"Footer_container__188QZ","download":"Footer_download__1yLe6","active":"Footer_active__3wB70","label":"Footer_label__1akhn"};